import { defineComponent } from 'vue';
import FormField from 'pk/components/Form/components/FormField.vue';
import FormMixins from 'pk/components/Form/FormMixins';
import UIService from 'pk/service/UIService';
import PopupAreasService from '../Popup/PopupAreasService';
export default defineComponent({
  mixins: [FormMixins],
  components: {
    FormField
  },
  data() {
    return {
      innerName: '',
      PopupAreasService: new PopupAreasService()
    };
  },
  created() {
    this.initInnerName();
  },
  methods: {
    handleOpenSelect() {
      if (this.field.disabled) return;
      return this.PopupAreasService.open({
        value: this.innerValue
      }).then(data => {
        this.innerValue = data;
        this.initInnerName();
      }).catch(err => UIService.toast.bizFail(err));
    },
    initInnerName() {
      const len = this.innerValue.length;
      this.innerName = len ? `已选择${len}个地区` : '';
    },
    handleClear() {
      this.innerValue = [];
      this.initInnerName();
    }
  }
});